import React from 'react';
import { Box } from '@mui/material';

import { MessageType } from '../../store/types/Message.types';

import GiftTextMessage, { IGiftTextMessageProps } from './GiftTextMessage';
import GiftCustomizingMessage, { IGiftCustomizingMessageProps } from './GiftCustomizingMessage';
import GiftVideoMessage from './GiftVideoMessage';

export interface IGiftMessageFactoryProps extends IGiftTextMessageProps, IGiftCustomizingMessageProps {
  type: MessageType;
}

const GiftMessageFactory = ({ type, ...componentsProps }: IGiftMessageFactoryProps): JSX.Element => {
  switch (type) {
    case MessageType.text:
      return <GiftTextMessage {...componentsProps} />;
    case MessageType.image:
      return <GiftCustomizingMessage {...componentsProps} />;
    case MessageType.video:
      return <GiftVideoMessage {...componentsProps} />;
    default:
      return (
        <Box fontFamily="Lato" color="primary.main">
          Undefined message component...
        </Box>
      );
  }
};

export default GiftMessageFactory;
